import CachedIcon from '@mui/icons-material/Cached';
import {
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { FC } from 'react';
import { TStatMinerDetail } from '../../../../api/types';
import { formatNumber } from '../../../../abelcommon';
import { useTranslation } from 'react-i18next';

interface IStatisticSectionProps {
  statMinerData: TStatMinerDetail[];
  onRefetchStatMiner: () => void;
  isFetching?: boolean;
}

export const StatisticSection: FC<IStatisticSectionProps> = ({ statMinerData, onRefetchStatMiner, isFetching }) => {
  const { t } = useTranslation();
  return (
    <Card>
      <CardHeader
        title={t('statisticSectionPage.statistics')}
        action={
          <IconButton aria-label="reload" onClick={onRefetchStatMiner}>
            {isFetching ? (
              <CachedIcon
                sx={{
                  '@keyframes spin': {
                    '0%': {
                      transform: 'rotate(360deg)',
                    },
                    '100%': {
                      transform: 'rotate(0deg)',
                    },
                  },
                  animation: 'spin 1s linear infinite',
                }}
              />
            ) : (
              <CachedIcon />
            )}
          </IconButton>
        }
      />
      <CardContent sx={{ overflow: 'auto' }}>
        <TableContainer sx={{ overflow: 'auto' }}>
          <Table sx={{ minWidth: '500px' }}>
            <TableHead>
              <TableRow>
                <TableCell>{t('statisticSectionPage.cardType')}</TableCell>
                <TableCell>{t('statisticSectionPage.cardCount')}</TableCell>
                <TableCell>{t('statisticSectionPage.hashRate')} (Mh/s)</TableCell>
                <TableCell>{t('statisticSectionPage.averageHashRate')} (Mh/s)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {statMinerData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} sx={{ textAlign: 'center' }}>
                    {t('global.noData')}
                  </TableCell>
                </TableRow>
              ) : (
                statMinerData.map((row, index) => (
                  <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell component="th" scope="row">
                      {row.cardType}
                    </TableCell>
                    <TableCell>{row.cardCount}</TableCell>
                    <TableCell>{formatNumber(row.hashrate, { maximumFractionDigits: 2 })}</TableCell>
                    <TableCell>{formatNumber(row.avgHashRate, { maximumFractionDigits: 2 })}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};
